module.exports = __webpack_public_path__ + "a4169739db3ace6b6d829b39cd22073e.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/power_has_a_price-1024.jpg
// module id = 501
// module chunks = 0